import { api } from "../../api/client";
import type { ThreatTo } from "../../wizard/ThreatStep";

export type IntelKind = "note" | "alert" | "observation";
export type IntelSeverity = "low" | "medium" | "high" | "critical";
export type Classification = "unclassified" | "restricted" | "secret";

export interface IntelItem {
  id: string;
  kind: IntelKind;
  severity: IntelSeverity;
  classification: Classification;
  title: string;
  body: string;
  branchId: string;
  wardId: string | null;
  constituencyId: string | null;
  publishedBy: string;
  publishedAt: string;
  redactedAt: string | null;
  redactedBy: string | null;
  redactionReason: string | null;
  threatTo?: ThreatTo;
  threatTarget?: string | null;
  threatDetails?: string | null;
}

interface List<T> { items: T[]; }

export interface IntelCreate {
  kind?: IntelKind;
  severity?: IntelSeverity;
  classification?: Classification;
  title: string;
  body: string;
  branchId: string;
  pollingStationId?: string;
  threatTo?: ThreatTo;
  threatTarget?: string;
  threatDetails?: string;
}

export const IntelApi = {
  list: (filters?: { severity?: IntelSeverity; kind?: IntelKind; branchId?: string }) => {
    const qs = new URLSearchParams();
    if (filters?.severity) qs.set("severity", filters.severity);
    if (filters?.kind) qs.set("kind", filters.kind);
    if (filters?.branchId) qs.set("branchId", filters.branchId);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return api<List<IntelItem>>(`/intel${suffix}`);
  },
  publish: (body: IntelCreate) =>
    api<IntelItem>("/intel", { method: "POST", body: JSON.stringify(body) }),
  redact: (id: string, reason: string) =>
    api<IntelItem>(`/intel/${id}/redact`, { method: "POST", body: JSON.stringify({ reason }) }),
};
